<template>
	<div v-if="season_mare_local">
		<b-alert :show="goal_porte_ecrase" variant="info" dismissible @dismissed="goal_porte_ecrase = false">{{ $t('gynecologie.objectif_porte_ecrase') }}</b-alert>
		<div class="mb-2 d-md-none">
			<b-button class="btn-block" variant="primary" @click.prevent="openAddGoal">{{ $t('global.ajouter') }} <font-awesome-icon :icon="['fal', 'plus']" /></b-button>
		</div>
		<div class="form-row align-items-center d-none d-md-flex font-weight-bold goals-header">
			<div class="col-1">#</div>
			<div class="col-3">{{ $t('horse.etalon') }}</div>
			<div class="col-3">{{ $t('gynecologie.goal') }}</div>
			<div class="col-4">{{ $t('monte.status_contract') }}</div>
			<div class="col-1 text-right">
				<b-button variant="primary" @click.prevent="openAddGoal">{{ $t('global.ajouter') }} <font-awesome-icon :icon="['fal', 'plus']" /></b-button>
			</div>
		</div>
		<LoadingSpinner v-if="loading" />
		<draggable v-else class="list-group list-group-left" :list="goals" v-bind="dragOptions" group="colonne" @update="debouncedOrder">
			<div v-for="(goal, index) in goals" class="list-group-item align-items-center" :key="goal.seasonmaregoals_id">
				<div class="form-row align-items-center">
					<div class="col-12 col-md-1 d-flex align-items-center mb-1 mb-md-0">
						{{ index+1 }}
						<b-button variant="secondary" class="drag-handle d-none d-md-inline-block ml-2 order-md-last"><font-awesome-icon :icon="['fal', 'sort-alt']" /></b-button>
						<b-button variant="secondary" class="d-md-none ml-2" :disabled="index === 0" @click.prevent="moveGoal(index, -1)"><font-awesome-icon :icon="['fal', 'angle-up']" /></b-button>
						<b-button variant="secondary" class="d-md-none ml-1" :disabled="index === goals.length - 1" @click.prevent="moveGoal(index, 1)"><font-awesome-icon :icon="['fal', 'angle-down']" /></b-button>
					</div>
					<div class="col-12 col-md-3 mb-1 mb-md-0">
						<span class="d-md-none font-weight-bold mr-1">{{ $t('horse.etalon') }} :</span>
						<router-link :to="{ name: 'HorseFicheInfo', params: { horse_id: goal.horse.horse_id }}">{{ goal.horse.horse_nom }}</router-link>
					</div>
					<div class="col-12 col-md-3 mb-1 mb-md-0">
						<span class="d-md-none font-weight-bold mr-1">{{ $t('gynecologie.goal') }} :</span>
						{{ $t('gynecologie.goal_type.'+goal.seasonmaregoals_type) }}
					</div>
					<div class="col-12 col-md-4 mb-1 mb-md-0">
						<span class="d-md-none font-weight-bold mr-1">{{ $t('monte.status_contract') }} :</span>
						<span v-if="goal.seasonmaregoals_type == 'congele' && !isOnline">{{ $t('error.LNOC') }}</span>
						<template v-else>
							<span :class="getStatusColor(goal)">
								<font-awesome-icon v-if="!goal.status" style="color:red;" :icon="['fal', 'times']" />
								{{ goal.status }} <template v-if="goal.porteuse && goal.porteuse.horse"> - <router-link :to="{ name: 'HorseFicheInfo', params: { horse_id: goal.porteuse.horse.horse_id }}">{{ goal.porteuse.horse.horse_nom }}</router-link></template>
							</span>
							<template v-if="goal.contract_num"> - {{ $t('monte.numero_contrat') }}
								<router-link :to="{ name: 'ContractFormv2', params: { contract_id: goal.contract_id }}">
									<strike v-if="goal.contract_canceled">{{ goal.contract_num }}</strike>
									<span v-else>{{ goal.contract_num }}</span>
								</router-link>
						</template>
						</template>
					</div>
					<div class="col-12 col-md-1 text-md-right">
						<b-button class="btn-sm" variant="secondary" @click.prevent="openConfirmDeleteGoal(goal)"><font-awesome-icon :icon="['fal', 'trash-alt']" /></b-button>
					</div>
			    </div>
			</div>
		</draggable>

		<b-modal ref="modal-protocole" hide-footer>
			<template v-slot:modal-title>
				{{ $t('gynecologie.add_goal') }}
			</template>

			<div class="row">
				<div class="col-4">
					<label>{{ $t('horse.etalon') }}*</label>
				</div>
				<div class="col-6">
                    <e-select
                        v-model="goal_horse"
                        id="horses"
                        track-by="horse_nom"
                        label="horse_nom"
                        :options.sync="horses"
                        :searchable="true"
                        :allow-empty="false"
                        :show-labels="false"
                    >
                        <template slot="singleLabel" slot-scope="{ option }">{{ option.horse_nom }}</template>
                        <template slot="noOptions">{{ $t('global.list_empty') }}</template>
                    </e-select>
				</div>
				<div class="col-4">
					<label>{{ $t('gynecologie.type_goal') }}*</label>
				</div>
				<div class="col-6">
					<e-select
						id="goal_type"
						v-model="goal_type"
						:options="goal_types"
                        :allow-empty="false"
					>
	                    <template slot="option" slot-scope="{ option }">{{ $t('gynecologie.goal_type.'+option) }}</template>
	                    <template slot="singleLabel" slot-scope="{ option }">{{ $t('gynecologie.goal_type.'+option) }}</template>
						<template slot="noOptions">{{ $t('global.list_empty') }}</template>
					</e-select>
				</div>
			</div>

			<div class="text-center">
				<a class="btn btn-primary mt-3" href="#" @click.prevent="checkForm">{{ $t('global.enregistrer') }} <font-awesome-icon v-if="processing" :icon="['fal', 'spinner']" pulse /><font-awesome-icon v-else :icon="['fal', 'save']" /></a>
			</div>
		</b-modal>

		<ModalConfirm 
			ref="modal_delete" 
			:icon="['fal', 'trash-alt']"
			:text_title="$t('gynecologie.delete_goal_title')"
			:text_question="$t('gynecologie.delete_goal_question')"
			:text_message="$t('modal.general.avertissement_suppression')"
			:text_button_ok="$t('action.supprimer')"
			:text_button_cancel="$t('global.annuler')"
			:callback_validation="confirmDeleteGoal"
			:callback_cancel="closeModal"
		/>
	</div>
</template>

<style lang="scss" scoped>
span.green {
	background: limegreen;
	color: white;
	padding: 5px;
}

/* Aligne l'en-tête sur les colonnes des .list-group-item (padding horizontal Bootstrap : 1.25rem) */
.goals-header {
	padding-left: 1.25rem;
	padding-right: 1.25rem;
}
</style>

<script type="text/javascript">
    import Gynecologie from "@/mixins/Gynecologie.js"
    import PlanningMonte from "@/mixins/PlanningMonte.js"
    import draggable from 'vuedraggable'
    import _debounce from 'lodash/debounce'
    import _isEmpty from 'lodash/isEmpty'

	export default {
		name: 'Goals',
		props: ['season', 'season_mare', 'mare_id', 'date'],
		mixins: [Gynecologie, PlanningMonte],
		data () {
			return {
				loading: false,
				processing: false,
				season_local: null,
				season_mare_local: null,
				goals: [],
                // Le drag ne se fait que via la poignée .drag-handle (masquée sur mobile → pas de drag sur mobile)
                dragOptions: {
                    animation: 200,
                    handle: '.drag-handle'
                },
                debouncedOrder: _debounce(this.updateOrder, 500),
                horses: [],
                goal_horse: null,
                goal_types: ['porte', 'transplante', 'congele', 'transplante_exterieur', 'mep_congele', 'transfert', 'poulinage'],
                goal_type: '',
                goal_delete: null
			}
		},

		mounted() {
			this.init_component()
		},

		methods: {
			async init_component() {
				this.loading = true
				if(this.mare_id && this.date && !this.season_mare) {
					const seasons = await this.getCurrentSeason(this.date)
					if(seasons.length == 0) return false
					this.season_local = seasons[0]
					this.season_local.name = this.season_local.season_label
					const season_mares = await this.loadSeasonMareBySeasonHorse(this.mare_id, this.season_local.season_id, true)
					if(season_mares.length == 0) return false
					this.season_mare_local = season_mares[0]
				}
				else {
					this.season_local = this.season
					if(this.season.season_label)
						this.season_local.name = this.season.season_label
					this.season_mare_local = this.season_mare
				}

				if(!this.season_mare_local) {
					return false
				}

				this.goals = await this.getGoalsBySeasonMare(this.season_mare_local)
				this.$emit('update:goals', this.goals)
				this.loading = false

				if(this.horses.length == 0) {
					this.horses = await this.getHorsesStallion(false)
				}
			},

			// Déplacement d'un objectif via les boutons up/down (mobile) : direction = -1 (haut) ou +1 (bas)
			moveGoal(index, direction) {
				const newIndex = index + direction
				if(newIndex < 0 || newIndex >= this.goals.length) return
				const goals = this.goals.slice()
				const moved = goals.splice(index, 1)[0]
				goals.splice(newIndex, 0, moved)
				this.goals = goals
				this.updateOrder()
			},
			async updateOrder() {
				const orders = {}
				this.goals.forEach((goal, index) => {
					orders[index] = goal.seasonmaregoals_id
				})
				await this.saveGoalOrder(orders)
				// Pousse le nouvel ordre au serveur pour éviter qu'une synchro descendante ne l'écrase
				await this.$sync.force()
				this.successToast('toast.info_save_succes')
			},

			openConfirmDeleteGoal(goal) {
				this.goal_delete = goal
				this.$refs.modal_delete.openModal()
			},

			async confirmDeleteGoal() {
				await this.deleteGoal(this.goal_delete.seasonmaregoals_id)
				this.goal_delete = null
				this.closeModal()
				this.init_component()
			},

			closeModal() {
				this.$refs.modal_delete.closeModal()
			},

			openAddGoal() {
				this.goal_horse = null
				this.goal_type = null
				this.$refs['modal-protocole'].show()
			},

			getStatusColor(goal) {
				if (goal.status && (goal.status.indexOf('DG+') !== -1 || goal.status.indexOf('#') !== -1)) return 'green'
			},

			async checkForm() {
				if(!this.goal_horse || _isEmpty(this.goal_type)) {
					this.failureToast("formulaire.erreur_champs_non_remplis")
					return false
				}
				this.processing = true
				const overwritten = await this.saveGoal(this.season_mare_local.seasonmare_id, this.goal_horse.horse_id, this.goal_type)
				if(overwritten) {
					this.goal_porte_ecrase = true
				}
				await this.updateOrder()
				this.processing = false
				this.$refs['modal-protocole'].hide()
				this.init_component()
			}
		},

		watch: {
			date() {
				this.init_component()
			}
		},

		computed: {
			isOnline() {
				return window.navigator.onLine
			}
		},

		components: {
            LoadingSpinner: () => import('GroomyRoot/components/Logos/LoadingSpinner_35'),
			ModalConfirm: () => import('GroomyRoot/components/Modals/ModalConfirm'),
            draggable 
		}
	}

</script>